import Cookie from '@wetransfer/concorde-cookie';

import { AppConfig } from '../core-bundle/config/app-config';

import Store from '@app/store';
import Router from '@module/router';
import Analytics from '@module/analytics';

export const init = () => {
  // Don't do this on small windows (because it will force full panel)
  if (window.innerWidth <= 1050) {
    return;
  }

  // Only on homepage
  const { route } = Store.getState();
  if (route.path !== '/') {
    return;
  }

  // Not if the user signed out in the last 30 minutes
  if (Cookie.get(AppConfig.cookies.signout.name)) {
    return;
  }

  const showPanel = () => {
    const { route } = Store.getState();
    if (!route.isPanelOpen) {
      Analytics.trackStructEvent({
        category: 'plus',
        action: 'show_halfpanel_triggered',
      });

      Router.navigateTo('/log-in', Router.SILENT);
    }
  };

  // Open panel if Plus user is not logged in
  const { user } = Store.getState();
  if (!user.loggedIn && Boolean(Cookie.get(AppConfig.cookies.plus.name))) {
    setTimeout(showPanel, AppConfig.panel.openDelay);
  }
};

init();
